import { render, staticRenderFns } from "./LinkDialog.vue?vue&type=template&id=a790c21e&scoped=true&"
import script from "./LinkDialog.vue?vue&type=script&lang=js&"
export * from "./LinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./LinkDialog.vue?vue&type=style&index=0&id=a790c21e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a790c21e",
  null
  
)

export default component.exports